export default {
  payment: {
    success: {
      title: "支付成功",
      description: "您的支付已成功处理。感谢您的购买。"
    },
    cancel: {
      title: "支付已取消",
      description: "您已取消支付。您可以随时重新尝试。"
    },
    error: {
      title: "支付失败",
      description: "处理您的支付时出现错误。请稍后重试。"
    }
  },
  common: {
    loading: '加载中...',
    error: '错误',
    success: '成功',
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    edit: '编辑',
    delete: '删除',
    back: '返回',
  },
  nav: {
    home: '首页',
    download: '下载',
    profile: '个人中心',
    login: '登录',
    logout: '退出登录',
    appName: '拇指琴跟弹'
  },
  home: {
    hero: {
      title: '跟弹学习拇指琴',
      subtitle: '跟随指引，按照自己的节奏练习。开始演奏你喜欢的曲目。',
      cta: '立即体验'
    },
    features: {
      title: '核心功能',
      subtitle: '为您的拇指琴学习提供全方位支持',
      smartPlay: {
        title: '跟弹指引系统',
        description: '准确的光标指引，帮助您掌握演奏节奏',
        features: [
          '清晰的光标指引，把握演奏节奏',
          '可调节的播放速度，适应练习需求',
          '灵活的暂停继续，随心把控进度'
        ]
      },
      sharing: {
        title: '自制琴谱工具',
        description: '专业的拇指琴谱编辑工具，让创作变得简单自然',
        features: [
          '直观的琴谱编辑器，轻松创作',
          '专业的记谱工具，适合各层次用户',
          '云端保存乐谱，随时查看编辑'
        ]
      },
      library: {
        title: '官方曲库资源',
        description: '精心策划的曲目库，满足不同层次的学习需求',
        features: [
          '经典名曲收录，提升品味',
          '流行歌曲改编，轻松上手',
          '难度分级系统，循序渐进'
        ]
      }
    }
  },
  download: {
    hero: {
      title: '开启您的音乐之旅',
      subtitle: '下载应用，立即体验卡林巴跟弹的魅力'
    },
    platforms: {
      appStore: '从 App Store 下载',
      googlePlay: '下载安卓安装包',
      androidComingSoon: '即将上线'
    },
    features: {
      instant: {
        title: '即刻开始',
        description: '无需下载安装，扫码即可使用，随时随地练习'
      },
      sync: {
        title: '云端同步',
        description: '学习进度云端保存，多设备无缝切换'
      },
      support: {
        title: '专业支持',
        description: '提供详细教程和技术支持，确保最佳学习体验'
      }
    }
  },
  auth: {
    login: {
      title: '欢迎回来',
      emailPlaceholder: '邮箱',
      passwordPlaceholder: '密码',
      loginButton: '登录',
      googleLogin: '使用 Google 账号登录',
      forgotPassword: '忘记密码？',
      noAccount: '没有账号？',
      register: '立即注册',
      rememberMe: '记住我'
    },
    register: {
      title: '创建账号',
      emailPlaceholder: '邮箱',
      passwordPlaceholder: '密码',
      confirmPasswordPlaceholder: '确认密码',
      registerButton: '注册',
      hasAccount: '已有账号？',
      login: '立即登录',
      passwordMismatch: '两次输入的密码不一致'
    },
    resetPassword: {
      title: '重置密码',
      emailPlaceholder: '请输入您的邮箱',
      newPasswordPlaceholder: '新密码',
      codePlaceholder: '验证码',
      sendCode: '获取验证码',
      resetButton: '重置密码',
      backToLogin: '返回登录'
    },
    google: {
      processing: '正在处理 Google 登录，请稍候...',
      success: 'Google 登录成功',
      failed: 'Google 登录失败',
      retryLater: 'Google 登录失败，请稍后重试',
      noAuthCode: '未收到授权码',
      noToken: '登录响应中缺少 token',
      redirecting: '登录成功，正在跳转...',
      returningToLogin: '即将返回登录页面...'
    }
  },
  profile: {
    title: '个人资料',
    nickname: {
      label: '昵称',
      notSet: '未设置',
      placeholder: '请输入新昵称',
      maxLength: '最多20个字符'
    },
    account: {
      title: '账号设置',
      changePassword: '修改密码'
    },
    danger: {
      title: '危险操作',
      deleteAccount: '删除账号',
      deleteConfirm: {
        title: '删除账号',
        content: '确定要删除账号吗？此操作无法撤销。我们将向您的邮箱发送验证码。'
      },
      codeSent: '验证码已发送至您的邮箱',
      enterCode: '请输入验证码',
      codePlaceholder: '请输入验证码',
      sendCode: '发送验证码',
      deleteSuccess: '账号已成功删除'
    }
  }
};